export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4683.3f5d658e.jpg";